import { Component, Input } from '@angular/core';
import { LayoutService } from '../service/app.layout.service';

const SCALE_KEY = 'fz-scale';

/** Appearance panel: the theme gallery and text size. Opened from the topbar, or its own button where there is no topbar (login). */
@Component({
    selector: 'app-config',
    templateUrl: './app.config.component.html'
})
export class AppConfigComponent {
    /** Login and other pages without the topbar show a floating button to open the panel. */
    @Input() minimal: boolean = false;

    readonly scales: number[] = [12, 13, 14, 15, 16];

    constructor(public layoutService: LayoutService) {}

    get visible(): boolean {
        return this.layoutService.state.configSidebarVisible;
    }

    set visible(value: boolean) {
        this.layoutService.state.configSidebarVisible = value;
    }

    get scale(): number {
        return this.layoutService.config.scale;
    }

    get lightThemes() {
        return this.layoutService.themes.filter(t => t.mode === 'light');
    }

    get darkThemes() {
        return this.layoutService.themes.filter(t => t.mode === 'dark');
    }

    open() {
        this.layoutService.showConfigSidebar();
    }

    pick(id: string) {
        this.layoutService.applyTheme(id);
    }

    setScale(scale: number) {
        this.layoutService.config.scale = scale;
        document.documentElement.style.fontSize = scale + 'px';
        try {
            localStorage.setItem(SCALE_KEY, String(scale));
        } catch {
            // Storage blocked: the size still applies for this visit.
        }
    }
}
